module.exports = __webpack_public_path__ + "static/img/挂锁1.f286276.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/guaLock/挂锁1.gif
// module id = hw6l
// module chunks = 0